export function checkStringEnum(obj: object, enumVal: string): boolean {
  return Object.keys(obj).filter(key => obj[key] === enumVal).length === 1
}